/**
 * widgetNames.ts — single source of truth for RudderStack `widget_name` /
 * `form_name` slugs.
 *
 * IMPORT-FREE ON PURPOSE: plain string constants, no `@/constants/admin/*`
 * (or any) imports — so referencing this from public-facing widgets can NEVER
 * drag admin code into the public bundle. One name per logical widget (all
 * variants of a widget share one name). Part of the decoupled analytics
 * feature — delete alongside rudderStackEvents.ts to fully remove.
 */
export const WIDGET_NAMES = {
	ABOUT: "about_us",
	TOP_BANNER: "top_banner",
	COURSE_OUTCOME: "course_outcome",
	BANNER_VIDEO: "banner_video",
	PROGRAM_BENEFITS: "program_benefits",
	SKILLS: "skills",
	PLACEMENTS: "placements",
	LEADERS: "leaders",
	VISIONARIES: "visionaries",
	LEARN_FROM_LEADERS: "learn_from_leaders",
	WHO_IS_THIS_PROGRAM_FOR: "who_is_this_program_for",
	APPLICATION_PROCESS: "application_process",
	PROGRAM_STRUCTURE: "program_structure",
	COMPARISON: "comparison",
	CERTIFICATION: "certification",
	FACULTY: "faculty",
	PROGRAM_FEE: "program_fee",
	TESTIMONIALS: "testimonials",
	FAQ: "faq",
	CASE_STUDY: "case_study",
	PROGRAM_CARDS: "program_cards",
	KEY_NUMBERS: "key_numbers",
	DIGITAL_LEARNING: "digital_learning",
	PARA_TEXT: "para_text",
	FOOTER: "footer",
	MENU_ITEM: "menu_item",
	LEAD_FORM_2: "lead_form_2",
	LEAD_FORM_9: "lead_form_9",
	LEAD_FORM_2001: "lead_form_2001",
	LEAD_FORM_5002: "lead_form_5002",
	/**
	 * The config-driven custom lead form. ONE name for every CMS-authored form rather than
	 * one per config: `form_name` is the analytics dimension analysts group by, and minting
	 * a new value each time an author clicks "New Lead Form" would fragment every funnel.
	 * Which config produced the event is a property, not an identity.
	 */
	LEAD_FORM_CUSTOM: "lead_form_custom",
	LEAD_FORM_5018: "lead_form_5018",
} as const;
